import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../shared/services/base.service';
import { Status } from '../models/status.model';

@Injectable({
  providedIn: 'root'
})
export class StatusService extends BaseService<Status> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/status`, injector);
   }
}
